// src/pages/ApplicationChampionshipSeason/shared/components/WizardStepFooter.tsx
import { FunctionComponent, ReactElement } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

type WizardStepFooterProps = {
  onBack?: () => void;
  onCancel: () => void;
  primaryLabel: string;
  onPrimary: () => void;
  primaryLoading?: boolean;
  /** Quando true, desabilita o botão principal (regras de bloqueio do step). */
  primaryDisabled?: boolean;
  primaryColorScheme?: string;
  primaryLeftIcon?: ReactElement;
  primaryRightIcon?: ReactElement;
};

export const WizardStepFooter: FunctionComponent<WizardStepFooterProps> = ({
  onBack,
  onCancel,
  primaryLabel,
  onPrimary,
  primaryLoading,
  primaryDisabled,
  primaryColorScheme,
  primaryLeftIcon,
  primaryRightIcon,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      gap={3}
      mt={4}
      pt={6}
      borderTopWidth="1px"
      borderColor="gray.100"
    >
      {onBack ? (
        <Button
          variant="outline"
          color="gray.600"
          onClick={onBack}
          isDisabled={primaryLoading}
          leftIcon={<ChakraFeatherIcon name="arrow-left" size="16px" />}
        >
          {t('pages.application_season.components.season_wizard.footer.back')}
        </Button>
      ) : (
        <Box />
      )}

      <Flex direction={{ base: 'column', md: 'row' }} gap={3}>
        <Button
          variant="outline"
          color="gray.600"
          onClick={onCancel}
          isDisabled={primaryLoading}
        >
          {t('pages.application_season.components.season_wizard.footer.cancel')}
        </Button>
        <Button
          colorScheme={primaryColorScheme}
          onClick={onPrimary}
          isLoading={primaryLoading}
          isDisabled={primaryDisabled}
          leftIcon={primaryLeftIcon}
          rightIcon={primaryRightIcon}
        >
          {primaryLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
